import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-client',
  template: `
    <p>
      edit-client works!
    </p>
  `,
  styles: ``
})
export class EditClientComponent {

}
